import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import {
  useCreateIspMutation,
  useUpdateIspMutation
} from '../../redux/apis/domainsManagement/isp/dMIspApiSlice'
import CountriesDropdown from '../CountriesDropdown'

const EditCreateIsp = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateIspMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateIspMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      isp_name: record?.isp_name || '',
      abuse_email: record?.abuse_email || '',
      abuse_form: record?.abuse_form || '',
      country: record?.country?.id || '',
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      isp_name: Yup.string().required('Please Enter ISP Name'),
      abuse_email: Yup.string().required('Please Enter Abuse Email'),
      country: Yup.number().required('Please Enter Country')
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      // Check if there are specific field errors
      if (errorAdd.data.errors) {
        const errorMessages = Object.values(errorAdd.data.errors).flat()
        errorMessages.forEach(message => {
          toast.error(message)
        })
      } else if (errorAdd.data.message) {
        // Fallback to general message if no specific errors
        toast.error(errorAdd.data.message)
      }
    } else if (errorUpdate?.data) {
      // Check if there are specific field errors
      if (errorUpdate.data.errors) {
        const errorMessages = Object.values(errorUpdate.data.errors).flat()
        errorMessages.forEach(message => {
          toast.error(message)
        })
      } else if (errorUpdate.data.message) {
        // Fallback to general message if no specific errors
        toast.error(errorUpdate.data.message)
      }
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('ISP created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('ISP updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit ISP` : 'Create ISP'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">ISP Name</label>
        <Input
          type='text'
          name='isp_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.isp_name}
        />
        {validation.touched.isp_name && validation.errors.isp_name ? (
          <p className='text-danger'>{validation.errors.isp_name}</p>
        ) : null}
      </div>
      <div className=' mb-3 '>
        <CountriesDropdown
          onChange={e=>validation.setFieldValue('country', e)}
          onBlur={validation.handleBlur}
          value={validation.values.country}
          validation={validation}
        />
        {validation.touched.country && validation.errors.country ? (
          <p className='text-danger'>{validation.errors.country}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Abuse Email</label>
        <Input
          type='text'
          name='abuse_email'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.abuse_email}
        />
        {validation.touched.abuse_email && validation.errors.abuse_email ? (
          <p className='text-danger'>{validation.errors.abuse_email}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Abuse form</label>
        <Input
          type='text'
          name='abuse_form'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.abuse_form}
        />
        {validation.touched.abuse_form && validation.errors.abuse_form ? (
          <p className='text-danger'>{validation.errors.abuse_form}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateIsp
